import i18n from '@/lang/i18n'

export default {
    title: i18n.t('configuration.elementTitle.cases'),
    id: 'laboratoryCases',
    sidebar: [
        {
            id: 'localCasesTypes',
            label: i18n.tc('configuration.sections.caseTypes', 2),
            icon: 'far fa-chart-network',
            routeName: 'LocalCaseTypes',
            hasChildren: false
        },
        {
            id: 'localCasesValidationSituations',
            label: i18n.tc('configuration.sections.validationSituation', 2),
            icon: 'far fa-spell-check',
            routeName: 'LocalCaseValidationSituations',
            hasChildren: false
        }
    ]
}
